import { create } from 'zustand'

export interface StoreProps {
  email: string
  setEmail: (loading: string) => void
}

const useStore = create<StoreProps>((set) => ({
  email: '',
  setEmail: (email) => set({ email }),
}))

export default useStore
